// import Rellax from "rellax";
import { rellaxConfiguration } from './config/rellax.ts';
import { animationItemProcessor, animationIsRequired } from './utils.ts';
import { consoleString } from "../utils";


const classList:string[] = ['rellax']

const setupRellax = async () => {
  console.time('✅ rellax library scripts loaded in')
  await import("rellax")
    .then((Rellax) => {
      console.timeEnd('✅ rellax library scripts loaded in')
      animationItemProcessor(rellaxConfiguration, classList)
      return new Rellax.default('.rellax');
    })
    .catch((err) => {
      console.log(
        `%c❌ an error occurred while loading the rellax library\n`,
        consoleString.error,
        err
      )
    })
}

const initRellax = () => {
  return animationIsRequired(rellaxConfiguration) ? setupRellax() : false;
}

export {
  initRellax
}
